// extracted by mini-css-extract-plugin
export var legendIndicator = "_b6-1";
export var legendRight = "_b6-0";